import React from "react";
import { FaSpinner } from "react-icons/fa";
import "./InlineProfilesLinkingDropdown.scss";
import useModal from "../../Hooks/useModal";

/**
 * requires the following props: profiles, selectProfile, prefill
 */
function ModalProfiles(props) {
  const { toggleModal, modalLoading } = useModal();

  const pushProfiles = async (new_profiles) => {
    if (new_profiles) {
      let resultpushSelected = await props.pushSelected(new_profiles);
      return resultpushSelected;
    }
  };

  const {
    profiles,
    modalPrefill: { modal_name },
  } = props;

  let callbacks = pushProfiles;

  let extraData = {
    profiles: profiles,
    type: props.type,
    callbacks: pushProfiles,
    allowOptionsOnlyOnce: props.allowOptionsOnlyOnce,
    masterFieldArray: props.masterFieldArray,
    formValues: props.formValues,
    formVersionId: props.modalPrefill?.formVersionId,
  };

  return (
    <div
      style={profiles && profiles.length < 1 ? { display: "none" } : null}
      className="grid-row inline-profiles-linking-dd-container"
    >
      <div className="grid-col-8 inline-profiles-linking-dd">
        <span className="inline-profiles-linking-text">
          <b>Profiles are available for this section!</b>
        </span>
        <span className="inline-profiles-linking-text">
          &nbsp;Select profile(s) to populate the table below.
        </span>
      </div>

      <button
        type="button"
        onClick={() => {
          toggleModal(modal_name, "content", null, callbacks, extraData);
        }}
        className="usa-button btn-extra-wide"
      >
        {modalLoading ? <FaSpinner className="icon-spin" /> : ""} Select
        Profiles
      </button>
    </div>
  );
}

export default ModalProfiles;
